import React ,{ Component }from "react";
import { FiCast , FiLayers , FiUsers , FiMonitor } from "react-icons/fi";
import { LanguageContext } from '../../context/LanguageContext';
import translations from '../../translations';

class ServiceThree extends Component{
    static contextType = LanguageContext;

    render(){
        const {column } = this.props;
        const { language } = this.context;
        const t = translations[language];

        const ServiceList = [
            {
                icon: <FiCast />,
                title: t.services.items[0].title,
                description: t.services.items[0].description
            },
            {
                icon: <FiLayers />,
                title: t.services.items[1].title,
                description: t.services.items[1].description
            },
            {
                icon: <FiUsers />,
                title: t.services.items[2].title,
                description: t.services.items[2].description
            },
            {
                icon: <FiMonitor />,
                title: t.services.items[3].title,
                description: t.services.items[3].description
            },
            {
                icon: <FiUsers />,
                title: t.services.items[4].title,
                description: t.services.items[4].description
            },
            {
                icon: <FiMonitor />,
                title: t.services.items[5].title,
                description: t.services.items[5].description
            }
        ];

        const ServiceContent = ServiceList.slice(0 , this.props.item);

        return(
            <React.Fragment>
                <div className="row">
                    {ServiceContent.map( (val , i) => (
                        <div className={`${column}`} key={i}>
                            {/* <a href="/service-details"> */}
                                <div className="service service__style--2">
                                    <div className="icon">
                                        {val.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title">{val.title}</h3>
                                        <p>{val.description}</p>
                                    </div>
                                </div>
                            {/* </a> */}
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceThree;
